export default function OfferMadeLabel() {
  return (
    <>
      <p className='offerMade'>You have made an offer on this listing</p>

      <style jsx>{`
        .offerMade {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 3rem;
          padding: 0.7rem 0;
          border-radius: 0 0 1rem 1rem;
          text-align: center;
          background: var(--success-color);
          color: #fff;
          font-weight: 700;
          font-size: 1.4rem;
        }

        @media (max-width: 1024px) {
          .offerMade {
            bottom: 6.3rem;
            width: 100%;
            height: 2.2rem;
            margin: 0;
            padding: 0.2rem 0;
            border-radius: 0;
            font-size: 1.2rem;
          }
        }
      `}</style>
    </>
  )
}
